var __jsx = React.createElement;
import * as React from 'react';
import styled from 'styled-components';
import { styles as S } from '@bob/design-system';
import * as ds from '@bob/design-system';
import * as url from '@bob/url';
export function AssociatedContents(_ref) {
  var brand = _ref.brand;

  if (brand.articles.length === 0) {
    return __jsx(React.Fragment, null);
  }

  return __jsx(Container, null, __jsx(S.heading.Title2, {
    as: "h2"
  }, "Contenu sur ", brand.name), __jsx(ds.LineGridLayout, null, brand.articles.map(function (article) {
    var _article$firstPublish;

    return __jsx(ds.ArticleCard, {
      key: article.slug,
      href: url.article({
        slug: article.slug,
        title: article.title
      }).path,
      date: new Date(article.forceUpdatedAt ? article.forceUpdatedAt : (_article$firstPublish = article.firstPublishedAt) !== null && _article$firstPublish !== void 0 ? _article$firstPublish : '').toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }),
      image: article.image,
      tag: article.category.name,
      title: article.title
    });
  })));
}
var Container = styled(ds.Container).withConfig({
  displayName: "AssociatedContents__Container",
  componentId: "sc-9hsahv-0"
})(["", "{margin-bottom:40px;}", "{width:100%;margin-bottom:80px;}"], S.heading.Title2, ds.LineGridLayout);